import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const setError = (_, { payload: error }) => error;

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.SHARE_AUDIT_FAILURE]: setError,
  [actionTypes.SHARE_AUDIT]: reset,
});
